import { render, staticRenderFns } from "./comment_sheet.html?vue&type=template&id=b0ef8770&external"
import script from "./comment_sheet.vue?vue&type=script&lang=js"
export * from "./comment_sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports